import { render, staticRenderFns } from "./hotBuy.vue?vue&type=template&id=c1cf46ee&scoped=true&"
import script from "./hotBuy.vue?vue&type=script&lang=js&"
export * from "./hotBuy.vue?vue&type=script&lang=js&"
import style0 from "./hotBuy.vue?vue&type=style&index=0&id=c1cf46ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cf46ee",
  null
  
)

export default component.exports